<template>
  <div>
    <div class="overlay"></div>
    <div class="modal_fixed">
      <div v-if="playersDetails.gamesWon === 0">
        <div class="modal_box modal_cont postgame postgame_2" id="modal_postgame2">
          <img class="x_close" src="static/images/games/Icon-Close-blue.png" @click="$emit('close')">
          <img src="static/images/postgame02.png" class="postgame_img">

          <div class="postgame_title">
              <span>{{ getTranslations.home_post_game_modal_oh_no }}</span><br>
              {{ getTranslations.home_post_game_modal_run_out_of_time }}<br>{{ getTranslations.home_post_game_modal_run_out_try_again }}
              {{ getTranslations.home_post_game_modal_do_not_give_up }}
          </div>
          <div class="postgame_title">
            {{ getTranslations.home_post_game_modal_try_again }}
          </div>
              <div class="postgame_txt">
                {{ getTranslations.home_post_game_modal_do_not_give_up }} <br>
                {{ getTranslations.home_post_game_modal_to_gather_even }}
              </div>
          <button type="button" class="postgame_btn" @click.prevent="$emit('startNewGame')">
            {{ getTranslations.home_post_game_modal_new_game }}
          </button>
          <div class="d_row end_row">
            <div class="unlocked_games"><span>{{ userDetails.availableGames }}</span> {{ getTranslations.home_post_game_modal_unlocked_games }}  </div>
            <router-link v-if="!hideStore" to="/home/store" class="buy_more_games">
              {{ getTranslations.home_post_game_modal_buy_more_games }}
            </router-link>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="modal_box modal_cont postgame postgame_2" id="modal_postgame1">
          <img class="x_close" src="static/images/games/Icon-Close-blue.png" @click="$emit('close')">
          <img src="static/images/postgame01.png" class="postgame_img">

          <div class="postgame_title">
            <span>{{ getTranslations.home_post_game_modal_wow }}</span> <br>
            {{ getTranslations.home_post_game_modal_congr }}
          </div>
          <div class="d_row points_answers">
            <div class="d_col left">
              <p><span>{{ playersDetails.gamesWon }}</span></p>
              <p>{{ getTranslations.home_post_game_modal_correct_answers }}</p>
            </div>
            <div class="d_col right">
              <p><span>{{ playersDetails.pointsEarned }}</span></p>
              <p>{{ getTranslations.home_post_game_modal_bonus_points }}</p>
            </div>
          </div>
          <div class="postgame_txt">
            {{ getTranslations.home_post_game_modal_do_not_give_up }} <br>
            {{ getTranslations.home_post_game_modal_to_gather_even }}
          </div>
          <button type="button" class="postgame_btn" @click.prevent="$emit('startNewGame')">
            {{ getTranslations.home_post_game_modal_new_game }}
          </button>
          <div class="d_row end_row">
            <div class="unlocked_games"><span>{{ userDetails.availableGames }}</span>{{ getTranslations.home_post_game_modal_unlocked_games }}</div>
            <router-link v-if="!hideStore" to="/home/store" class="buy_more_games">
              {{ getTranslations.home_post_game_modal_buy_more_games }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapGetters, mapState } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';
import { startProgressBar, profileBar } from '../../../../common/jQuery';

export default {
  name: 'post-game-swipo',
  mixins: [IntegrationMixin],
  data() {
    return {
      categories: ['geography', 'arts', 'food', 'history', 'sports', 'music', 'science', 'world', 'math', 'movies', 'nature', 'languages'],
      iqLevel: {
        GENIUS: 'Genius',
        SUPERIOR: 'Superior',
        AVERAGE: 'Average',
      },
      numOfPossibleTexts: 2,
      showGraph: true,
    };
  },
  mounted() {
    this.showGraph = (!this.getIntegrationByName()) ? false : this.getIntegrationByName().value.addGraph;
    console.log(this.playersDetails);
    this.$nextTick(() => {
      startProgressBar();
      profileBar();
      /* eslint-disable */
      $(".progressbar__bar").each(function (t, e) {
        var n = $(e).data("percent");
        $(e).width(n + "%")
      })
    });
  },
  methods: {
    /* eslint-disable */
    calculateIqLevel() {
      return (this.playersDetails.iqPoints >= 140) ? this.iqLevel.GENIUS : (this.playersDetails.iqPoints < 140
      && this.playersDetails.iqPoints >= 120 ? this.iqLevel.SUPERIOR : this.iqLevel.AVERAGE);
    },
    recommendationText() {
      const index = Math.floor(Math.random() * this.numOfPossibleTexts) + 1;
      const iqLevel = this.calculateIqLevel().toLowerCase();
      return this.getTranslations['home_post_game_modal_recommendation_' +
      `${this.gameType.toLowerCase()}_` + `${this.gameMode.toLowerCase()}_` + `${iqLevel}` + '_text.' + `${index}`] ||
        this.getTranslations['home_post_game_modal_recommendation_' +
      `${this.gameType.toLowerCase()}_` + `${this.gameMode.toLowerCase()}_` + `${iqLevel}` + '_text.1'] || '';
     /* eslint-enable */
    },
  },
  computed: {
    ...mapState('common', [
      'hideStore',
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('game', [
      'gameType',
      'gameMode',
      'playersDetails',
    ]),
    calculatePercentage() {
      return Math.round((this.playersDetails.gamesWon / this.playersDetails.gamesPlayed) * 100);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/postgame/PostGameSwipo.vue